import * as Config from '../../../config';
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useDispatch } from "react-redux";
import PropTypes from 'prop-types';
import { debounce } from "throttle-debounce";
import './FilterInput.css';

import { setStateShortcuts } from "../shortcut/redux/actions/index";

function FilterInputV2({ flexShrink, type, placeholder, value, onValid, inputType = 'text' }) {
  const dispatch = useDispatch();
  const [val, setVal] = useState(value);
  const [focus, setFocus] = useState(false);
  const prepareFocus = () => {
    setFocus(true);
    dispatch(setStateShortcuts(false));
  }
  const prepareBlur = () => {
    setFocus(false);
    dispatch(setStateShortcuts(true));
  }

  useEffect(() => { setVal(value) }, [value])

  const debouncedApply = useCallback(debounce(1000, (v) => {
    onValid(type, v)
  }), [])
  const search = (value) => {
    setVal(value);
    debouncedApply(value);
  }
  const onChange = (e) => { search(e.target.value) }
  const onClear = () => { search(``) }

  const elInput = useRef();
  const forceFocus = () => {
    if (Config.TOUCH_ENABLED) {
      elInput.current.focus()
    }
  }

  return (
    <div className={`flexRow align filter-container ${(value.length > 0) && `extend`} ${focus && `focus`} ${flexShrink > 1 && `small`} `}
      style={{ flexShrink }}
      tabIndex={0}
      onFocus={prepareFocus}
      onBlur={prepareBlur}
    >
      <input ref={elInput} type={inputType} onChange={onChange} value={val}
        placeholder={placeholder} onFocus={prepareFocus} onBlur={prepareBlur}
        onClick={forceFocus} className={`filter-input-v2`}
      />
      { (value.length > 0) && (
        <div className="type-small brand-primary button-clear" onClick={onClear}>
          <span>Clear</span>
        </div>
      )}
    </div>
  )
}

FilterInputV2.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onValid: PropTypes.func.isRequired
}

export default FilterInputV2;
